<template>
  <div>
    <v-row justify="space-between">
      <div>
        <h4 class="subtitle-2 white--text">Quote settings</h4>
        <h3 class="title white--text">Trip inclusions</h3>
      </div>
      <div>
        <g-button label="Return" @onclick="$router.push({ name: 'admin_textconfig' })" />
        <save-button :onsave="updateTripInclusion" />
      </div>
    </v-row>
    <a-card>
      <v-row class="mb-2">
        <elwrapper label="Environment" texttop>
          <f-dropdown v-model="selectedEnv" :items="ENV" @change="getTripInclusion" hideClear />
        </elwrapper>
      </v-row>
      <v-row class="mb-2">
        <elwrapper label="Included" texttop>
          <f-textarea v-model="included" label="Included" rows="10" />
        </elwrapper>
      </v-row>
      <v-row class="mb-2">
        <elwrapper label="Excluded" texttop>
          <f-textarea v-model="excluded" label="Excluded" rows="10" />
        </elwrapper>
      </v-row>
      <v-row>
        <elwrapper label="Disclaimer" texttop>
          <f-textarea v-model="disclaimer" label="Disclaimer" rows="10" />
        </elwrapper>
      </v-row>
    </a-card>
  </div>
</template>

<script>
import ENV from "@/config/ENV";
export default {
  components: {},
  data() {
    return {
      ENV,
      selectedEnv: this.$store.getters["AccountStore/environment"],
      included: "",
      excluded: "",
      disclaimer: "",
    };
  },
  methods: {
    getTripInclusion(env) {
      this.$store
        .dispatch("TripInclusionsStore/getTripInclusion", { env })
        .then((data) => {
          this.included = data.included;
          this.excluded = data.excluded;
          this.disclaimer = data.disclaimer;
        })
        .catch((err) => this.$root.$error(err));
    },
    updateTripInclusion() {
      return this.$store
        .dispatch("TripInclusionsStore/updateTripInclusion", {
          env: this.selectedEnv,
          included: this.included,
          excluded: this.excluded,
          disclaimer: this.disclaimer,
        })
        .then(() => this.$root.$success("Trip Inclusions updated"))
        .catch((err) => this.$root.$error(err));
    },
  },
  mounted() {
    this.getTripInclusion(this.selectedEnv);
  },
};
</script>
